import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ApiResponse } from '../../classes/api-response';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { Constants } from '../../utils/constants';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'aw-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationComponent implements OnInit {

  constructor(private httpClient: HttpClient,
    public authService: AuthService,
    public snackBarService: SnackService,
    private router: Router) {

  }

  errorMessageText = "The token you inserted is not correct";
  completed = true;
  tokenText = '';
  private readonly errorMessage1 = 'Our Services are momentarily unavailable.';
  private readonly errorMessage2 = 'The token you inserted is not correct.';
  private readonly emailSentMessage = "The email has been sent!";

  private readonly ctrlFullPathVerification = `${environment.apiUrl}/public/email-verification`
  private readonly requestNewEmail = `${environment.apiUrl}/common-user`

  onResendEmailButtonClicked() {
    this.completed = false;
    this.httpClient.get<ApiResponse>(this.requestNewEmail).toPromise()
      .then((data) => {
        this.snackBarService.info(this.emailSentMessage);
      })
      .catch((data) => {
        this.snackBarService.error(this.errorMessage1);
      })
      .finally(() => { this.completed = true; });
  }

  @HostListener('document:keydown.enter')
  onVerifyButtonClicked() {

    if (!this.completed) return;

    let body = {
      token: this.tokenText.trim()
    };

    this.completed = false;
    this.httpClient.post<ApiResponse>(this.ctrlFullPathVerification, body).toPromise()
      .then((data) => {
        if (data.data === Constants.apiResponses.tokenIncorrect) {
          this.snackBarService.error(this.errorMessage2)
        }
        else if (data.data === Constants.apiResponses.tokenCorrect) {
          this.authService.onUserChange().subscribe(afterRefresh => {
            if (afterRefresh as string === 'tokenExpired') {
              this.authService.refreshUser();
              return;
            }
            let redirect = this.authService.redirectUrl;
            this.router.navigate([redirect]).then(() => { });
          });
        }
      })
      .catch(() => {
        this.snackBarService.error(this.errorMessage1);
      })
      .finally(() => { this.completed = true; });
  }

  ngOnInit(): void { }
}
